import Dropdown from './DropdownStyled';
import {Options} from '../../utils/types';
import {localizedMessage} from '../message/Message';
import PosaRedeemActions from '../../actions/PosaRedeemActions';
import React from 'react';
import Tooltip from './Tooltip';
import cx from 'classnames';

interface Props {
  psnCountry: string;
  psnToolTip: string;
  countries: Options[];
}

const callback = ({value}) => PosaRedeemActions.setPsnCountry(value);

const RedeemSectionPsnCountryDropDown = ({psnCountry, psnToolTip, countries}: Props) => {
  return (
    <>
      <div className="redeem-next next-select-platform">
        <strong>{localizedMessage('epic.code.redemption.posa.page.common.next')}:</strong>
        <span>{localizedMessage('epic.code.redemption.posa.page.redeem.psn.next')}</span>
      </div>
      <div className={cx('input-wrapper psnCountryInput', {verified: psnCountry})}>
        <Dropdown
          placeholder={localizedMessage('epic.code.redemption.posa.page.redeem.country')}
          options={countries}
          callback={callback}
        />
        <Tooltip content={psnToolTip} />
      </div>
    </>
  );
};

export default RedeemSectionPsnCountryDropDown;
